import React, { useEffect, useState } from 'react'
import Loader from '../../../components/Loader';
import { Link, useParams } from 'react-router-dom';
import PageHeading from '../../../components/PageHeading';
import OwnerProjectCard from './OwnerProjectCard';
import GetOwnerPortfolio from '../../../APIs/OwnerPortfolio/GetOwnerPortfolio';

export default function OwnerProjects() {
    const { ownerId } = useParams();
    const [ownerData, setOwnerData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [numberPages, setNumberOfPages] = useState([]);
    const [loader, setLoader] = useState(1);

    const loadOwnerPortfolio = async () => {
        try {
            let response = await GetOwnerPortfolio(ownerId);
            if (response?.status === 1) {
                setOwnerData(response?.responseValue?.reverse());
            }
            else {
                setOwnerData([]);
            }
        }
        catch (e) {
            setOwnerData([]);
        }
        finally {
            setLoader(0);
        }
    }

    const handlePrevious = () => {
        if (pageNumber !== 1) {
            setPageNumber(state => state - 1)
        }
        else {

        }
    }
    const handleNext = () => {
        if (pageNumber < numberPages?.length) {
            setPageNumber(state => state + 1);
        }
    };

    useEffect(() => {
        loadOwnerPortfolio();
    }, [ownerId]);
    
    return (
        <>
            <div className='container-fluid  '>
                <PageHeading pagename={"Owner Projects"} />
                <div className='project-conatiner mb-4'>
                    {
                        ownerData && ownerData?.slice(((pageSize * pageNumber) - pageSize), pageSize * pageNumber).map((val, ind) => {
                            return (
                                <OwnerProjectCard projectData={val} />
                            )
                        })
                    }

                </div>

                {ownerData?.length > 10 && (
                    <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-end">

                            <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handlePrevious();
                                    }}
                                >
                                    Previous
                                </Link>
                            </li>

                            {numberPages?.map((val, ind) => (
                                <li
                                    className={`page-item ${pageNumber === ind + 1 ? "active" : ""}`}
                                    key={ind}
                                >
                                    <Link
                                        className="page-link"
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setPageNumber(ind + 1);
                                        }}
                                    >
                                        {ind + 1}
                                    </Link>
                                </li>
                            ))}

                            <li
                                className={`page-item ${pageNumber === numberPages?.length ? "disabled" : ""
                                    }`}
                            >
                                <Link
                                    className="page-link"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNext();
                                    }}
                                >
                                    Next
                                </Link>
                            </li>

                        </ul>
                    </nav>
                )}
            </div>
            <Loader show={loader} />
        </>
    )
}
